// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"K7-z","colorTextValue":"L7-z","swatches":"M7-z","collapseLink":"N7-z","isCollapsed":"O7-z","dropdown":"P7-z","disabled":"Q7-z"};